import type { ISnippet } from "@/components/RenderedDie/ISnippet";
import {
  Object3D,
  Vector3,
  type WebGLProgramParametersWithUniforms,
} from "three";

export class LiquidMaterialDefinition implements ISnippet {
  velocity: Vector3 = new Vector3();
  angularVelocity: Vector3 = new Vector3();
  maxWobble: number = 0.01;
  wobbleSpeed: number = 1.0;
  recovery: number = 2.0;
  wobbleAmountX: number = 0;
  wobbleAmountZ: number = 0;
  wobbleAmountToAddX: number = 0;
  wobbleAmountToAddZ: number = 0;
  pulse: number = 0;
  lastPos: Vector3 = new Vector3();
  lastRot: Vector3 = new Vector3();
  time: number = 0;
  rootMesh: Object3D;
  liquidShader: WebGLProgramParametersWithUniforms;

  constructor(
    rootMesh: Object3D,
    liquidShader: WebGLProgramParametersWithUniforms,
  ) {
    this.rootMesh = rootMesh;
    this.liquidShader = liquidShader;
  }

  lerp(start: number, end: number, t: number): number {
    return start * (1 - t) + end * t;
  }

  clamp(num: number, min: number, max: number): number {
    return num <= min ? min : num >= max ? max : num;
  }

  Update(deltaTime: number) {
    this.time += deltaTime;
    this.wobbleAmountToAddX = this.lerp(
      this.wobbleAmountToAddX,
      0,
      deltaTime * this.recovery,
    );
    this.wobbleAmountToAddZ = this.lerp(
      this.wobbleAmountToAddZ,
      0,
      deltaTime * this.recovery,
    );
    this.pulse = 2 * Math.PI * this.wobbleSpeed;
    this.wobbleAmountX =
      this.wobbleAmountToAddX * Math.sin(this.pulse * this.time);
    this.wobbleAmountZ =
      this.wobbleAmountToAddZ * Math.sin(this.pulse * this.time);

    const rootWorldPositon = this.rootMesh.getWorldPosition(new Vector3());

    this.liquidShader.uniforms.u_WobbleX.value = this.wobbleAmountX;
    this.liquidShader.uniforms.u_WobbleZ.value = this.wobbleAmountZ;
    this.liquidShader.uniforms.u_ObjectPosition.value = rootWorldPositon;

    this.velocity = this.lastPos
      .clone()
      .sub(rootWorldPositon)
      .divideScalar(deltaTime);
    const rotation = new Vector3(
      this.rootMesh.rotation.x,
      this.rootMesh.rotation.y,
      this.rootMesh.rotation.z,
    );
    this.angularVelocity = rotation.clone().sub(this.lastRot);
    this.wobbleAmountToAddX += this.clamp(
      (this.velocity.x + this.angularVelocity.z * 0.2) * this.maxWobble,
      -this.maxWobble,
      this.maxWobble,
    );
    this.wobbleAmountToAddZ += this.clamp(
      (this.velocity.y + this.angularVelocity.x * 0.2) * this.maxWobble,
      -this.maxWobble,
      this.maxWobble,
    );
    this.lastPos = rootWorldPositon.clone();
    this.lastRot = rotation.clone();
  }
}
